__turbopack_context__.v({
  "blocksBackgroundColor": "userSettingsPageStyles-module-scss-module__mhWAhW__blocksBackgroundColor",
  "blocksFontColor": "userSettingsPageStyles-module-scss-module__mhWAhW__blocksFontColor",
  "centerContainer": "userSettingsPageStyles-module-scss-module__mhWAhW__centerContainer",
  "container": "userSettingsPageStyles-module-scss-module__mhWAhW__container",
  "displayContainer": "userSettingsPageStyles-module-scss-module__mhWAhW__displayContainer",
  "editable": "userSettingsPageStyles-module-scss-module__mhWAhW__editable",
  "flexGrow1": "userSettingsPageStyles-module-scss-module__mhWAhW__flexGrow1",
  "flexGrow5": "userSettingsPageStyles-module-scss-module__mhWAhW__flexGrow5",
  "followTable": "userSettingsPageStyles-module-scss-module__mhWAhW__followTable",
  "heading": "userSettingsPageStyles-module-scss-module__mhWAhW__heading",
  "icon": "userSettingsPageStyles-module-scss-module__mhWAhW__icon",
  "itemIcon": "userSettingsPageStyles-module-scss-module__mhWAhW__itemIcon",
  "itemRow": "userSettingsPageStyles-module-scss-module__mhWAhW__itemRow",
  "notificationDetails": "userSettingsPageStyles-module-scss-module__mhWAhW__notificationDetails",
  "notificationInfo": "userSettingsPageStyles-module-scss-module__mhWAhW__notificationInfo",
  "notificationSettings": "userSettingsPageStyles-module-scss-module__mhWAhW__notificationSettings",
  "optionsContainer": "userSettingsPageStyles-module-scss-module__mhWAhW__optionsContainer",
  "optionsContainerBackgroundImage": "userSettingsPageStyles-module-scss-module__mhWAhW__optionsContainerBackgroundImage",
  "row": "userSettingsPageStyles-module-scss-module__mhWAhW__row",
  "secondaryNavBackgroundColor": "userSettingsPageStyles-module-scss-module__mhWAhW__secondaryNavBackgroundColor",
  "sectionBorder": "userSettingsPageStyles-module-scss-module__mhWAhW__sectionBorder",
  "sendTestNotification": "userSettingsPageStyles-module-scss-module__mhWAhW__sendTestNotification",
  "settingsContainer": "userSettingsPageStyles-module-scss-module__mhWAhW__settingsContainer",
  "settingsTable": "userSettingsPageStyles-module-scss-module__mhWAhW__settingsTable",
  "subscriptionType": "userSettingsPageStyles-module-scss-module__mhWAhW__subscriptionType",
  "themeBackgroundColor": "userSettingsPageStyles-module-scss-module__mhWAhW__themeBackgroundColor",
  "themeFontColor": "userSettingsPageStyles-module-scss-module__mhWAhW__themeFontColor",
  "themeFontFamily": "userSettingsPageStyles-module-scss-module__mhWAhW__themeFontFamily",
  "title": "userSettingsPageStyles-module-scss-module__mhWAhW__title",
  "userDashboardButtons": "userSettingsPageStyles-module-scss-module__mhWAhW__userDashboardButtons",
});
